import setConstraints from './set-constraints';

export default {
  setConstraints,
};
